import {
  FilterTypeEqual,
  RenderTableFilterOptionProps,
} from '@monetize/types/common';
import { FunctionComponent as FC } from 'react';
import { getAccountById } from '../../../../api/accountsService';
import { MainSearchInput } from '../../MCustomSelect/components/MainSearchInput';
import { MCustomSelect } from '../../MCustomSelect/MCustomSelect';
import { useCustomSelectValue } from '../../MCustomSelect/useCustomSelectValue';

type AccountIdTableFilterOptionContentProps = RenderTableFilterOptionProps;

export const AccountIdTableFilterOptionContent: FC<
  AccountIdTableFilterOptionContentProps
> = ({
  filter,
  filterOption,
  handleFilterChange,
}: AccountIdTableFilterOptionContentProps) => {
  // `filter` is looked up by key alone, so a sibling option on the same key
  // (e.g. the Discount list's "Show Custom Discounts" toggle, whose value is
  // `eq:null`) lands here too - its value is not an account id to fetch.
  const accountId =
    filter?.operator === filterOption.operator
      ? (filter as FilterTypeEqual).value
      : '';
  const { internalValue, isLoading, onInternalValueChange } =
    useCustomSelectValue({
      value: accountId,
      setValue: (value: string) => {
        handleFilterChange(value, filterOption);
      },
      getOneById: getAccountById,
    });

  return (
    <MCustomSelect
      isLazy
      clearable
      itemTitle="accountName"
      itemValue="id"
      placeholder="Search"
      useMainInputAsSearchInput
      endpoint="api/accounts"
      MainInputComponent={MainSearchInput}
      value={internalValue}
      returnItem
      onChange={(val: any) => {
        onInternalValueChange(val);
      }}
      loading={isLoading}
    />
  );
};
